module.exports = __webpack_public_path__ + "fonts/MyriadPro-regular.6c518fc.OTF";